import styled from 'styled-components';

import { gridSizes } from 'utils/style';
import DatePickerCalendar from 'components/form/DatePickerCalendar/component';

export default styled(DatePickerCalendar)`
  padding: ${gridSizes('M')};
  width: 100%;
  justify-content: center;
  display: flex;
`;
